const CrossSell = (function ($) {
    const self = {
        gtm: {
            event: {
                continue: 'formContinue',
                generateLink: 'generateLink'
            }
        },
        elements: {
            sessionStorage: {
                termsAndConditions: 'tac'
            },
            ids: {
                termsAndConditionsWarning: '#terms-and-conditions-warning',
                termsAndConditionsCheckbox: '#terms-and-conditions-checkbox',
                dataShareWarning: '#data-share-warning',
                dataShareCheckbox: '#data-share-checkbox',
                consentGenerateButton: '#generate-button',
                emailWarningMessage: '#email-warning-field',
                consentHasEmailFlag: '#consent-has-email',
                emailValidHasEmailFlag: '#email-validation-has-email',
                buyapowaReferAFriend: '#bp_div',
                buyapowaRedirect: '#buyapowa-redirect'
            }
        },
        func: {
            init: function () {
                self.func.handleRedirects();
                self.func.bindings();
                self.func.buildDisplay();
            },
            bindings: function () {
                $(self.elements.ids.consentGenerateButton).on('click', self.func.consentGenerateButtonHandler);
            },
            buildDisplay: function () {
                self.func.hideConsentWarnings();
                self.func.showEmailWarning();
            },
            hideConsentWarnings: function () {
                $(self.elements.ids.termsAndConditionsWarning).hide();
                $(self.elements.ids.dataShareWarning).hide();
            },
            handleRedirects: function () {
                const hasAgreedTerms = sessionStorage.getItem(self.elements.sessionStorage.termsAndConditions);
                const hasReferAFriendComponent = $(self.elements.ids.buyapowaReferAFriend).length > 0;
                if (!hasAgreedTerms && hasReferAFriendComponent) {
                    window.location.replace($(self.elements.ids.buyapowaRedirect).val());
                }
                if (hasAgreedTerms && hasReferAFriendComponent) {
                    $(self.elements.ids.buyapowaReferAFriend).show();
                }
            },
            isValidConsent: function () {
                let isValid = true;
                if (!$(self.elements.ids.termsAndConditionsCheckbox).is(':checked')) {
                    $(self.elements.ids.termsAndConditionsWarning).show();
                    isValid = false;
                } else {
                    $(self.elements.ids.termsAndConditionsWarning).hide();
                }
                if (!$(self.elements.ids.dataShareCheckbox).is(':checked')) {
                    $(self.elements.ids.dataShareWarning).show();
                    isValid = false;
                } else {
                    $(self.elements.ids.dataShareWarning).hide();
                }
                return isValid;
            },
            showEmailWarning: function () {
                if (!self.func.hasEmail() && $(self.elements.ids.emailWarningMessage).length > 0) {
                    $(self.elements.ids.emailWarningMessage).show();
                }
            },
            hasEmail: function () {
                return ($(self.elements.ids.consentHasEmailFlag).prop('disabled')
                    || $(self.elements.ids.emailValidHasEmailFlag).prop('disabled'));
            },
            consentGenerateButtonHandler: function (e) {
                e.preventDefault();
                if (self.func.isValidConsent() && self.func.hasEmail()) {
                    window.dataLayer.push({
                        event: self.gtm.event.continue,
                        ctaClick: self.gtm.event.generateLink
                    });
                    sessionStorage.setItem(self.elements.sessionStorage.termsAndConditions, true);
                    window.location.replace($(self.elements.ids.consentGenerateButton).attr('href'));
                }

                const speed = 500;
                const top = 0;
                if (!self.func.hasEmail()) {
                    $('html, body').animate({
                            scrollTop: top
                        },
                        speed);
                }
            }
        }
    };
    return {
        Init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    CrossSell.Init();
});
